/**
 * Returns a range of numbers with min-value, max-value and stepsize
 * @param {number} min start of range
 * @param {number} max end of range
 * @param {number} step steps of range
 * @returns {number[]}
 */
export function getRange(min, max, step) {
  var range = [],
    j = 0;
  for (var i = min; i <= max; i += step) {
    range[j++] = i;
  }
  return range;
}



// WEBPACK FOOTER //
// ./src/components/Tools/utils.js